// Central location for all Azure AD scopes used in the app

export const FLW_API_SCOPE = 'cd1b8394-07a3-43b1-8aba-ce6ee572d0af/.default';

// Scopes requested during login (redirect/popup)
export const loginRequestScopes = [
  "email",
  "profile",
  FLW_API_SCOPE
  // Include it when permission is approved for 1P app
 // "User.Read"
];

// Scopes requested when calling Microsoft Graph
export const graphRequestScopes = [
  // Include it when permission is approved for 1P app
 // "User.Read"
];
